<template>
  <div class="footer-box flex-box" v-show="$route.meta.navShow" :class="$route.meta.navShow?'contsiner-bot':''">
    <div @click="to(0)">
      <img v-if="number != 0" src="../assets/tabbar/1.png" alt="" />
      <img v-if="number == 0" src="../assets/tabbar/11.png" alt="" />
      <p :class="number == 0?'footer_active':''">首页</p>
    </div>
    <div @click="to(1)">
       <img v-if="number != 1" src="../assets/tabbar/2.png" alt="" />
      <img v-if="number == 1" src="../assets/tabbar/22.png" alt="" />
      <p :class="number == 1?'footer_active':''">产品</p>
    </div>
    <div @click="to(2)">
       <img v-if="number != 2" src="../assets/tabbar/3.png" alt="" />
      <img v-if="number == 2" src="../assets/tabbar/33.png" alt="" />
      <p :class="number == 2?'footer_active':''">团队</p>
    </div>
    <div @click="to(3)">
       <img v-if="number != 3" src="../assets/tabbar/4.png" alt="" />
      <img v-if="number == 3" src="../assets/tabbar/44.png" alt="" />
      <p :class="number == 3?'footer_active':''">业绩</p>
    </div>
    <div @click="to(4)">
       <img v-if="number != 4" src="../assets/tabbar/5.png" alt="" />
      <img v-if="number == 4" src="../assets/tabbar/55.png" alt="" />
      <p :class="number == 4?'footer_active':''">我的</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "v-footer": "footer",
  },
  data() {
    return {
      number: 0,
    };
  },
  props: {},
  mounted() {
    
    // var token=localStorage.getItem("TOKEN")
    // this.$axios.post( `/v9/Index/bottomNavList`).then(res => {
    //     if(res.data.code==200){
    //       var that=this
    //       this.databottom=res.data.data
    //       //  this.databottom.map(function(value,i){
    //       //      that.urlbg=value.icon_link.split("?")[1].split("=")[1]
    //       //   })
    //     }
    // })
    // if(token!=null){
    //     this.$axios.post( `v1/message/getMessage`, {type: 1}).then(res => {
    //           this.number = res.data.sum_unread_number;
    //     })
    //   }
  },
  updated(){
    let router_path = this.$route.path;
    console.log(router_path);
    if(router_path == '/'){
      this.number = 0
    }else if(router_path == '/sedCreditPlan'){
      this.number = 1
    }else if(router_path == '/Management'){
      this.number = 2
    }else if(router_path == '/Achievement'){
      this.number = 3
    }else if(router_path == '/me'){
      this.number = 4
    }
  },
  methods: {
    to(path) {
      if (path == 0) {
        this.$router.push({ path: "/" });
      } else if (path == 1) {
        this.$router.push({ path: "/sedCreditPlan" });
      } else if (path == 2) {
        this.$router.push({ path: "/Management" });
      } else if (path == 3){
        this.$router.push({ path: "/Achievement" });
      } else if (path == 4) {
        this.$router.push({ path: "/me" });
      }
      this.number = path
    },
  },
};
</script>

<style scoped>
p {
  padding: 0;
  margin: 0;
}
.footer-box {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 60px;
  /* z-index: 99999; */
  border-top: 0.02rem solid #eee;
}
.footer_active{
  color:#0068FF!important;
}
.footer-box div {
  position: relative;
  width: 25%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.footer-box div img {
  width: 25px;
  height: 25px;
  margin-top: 10px;
}
.footer-box div p {
  margin-bottom: 6px;
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}
.active {
  color: #fe8103 !important;
}
.news_content {
  position: absolute;
  top: 3px;
  left: 3px;
  height: 6px;
  width: 6px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  background: #ff3333;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue